import { createFileRoute } from '@tanstack/react-router';
import { JourneysPersonOverviewRoute } from './-route-wrappers';

/**
 * `/journeys/people/:personId` — the address the embedded app links a profile at. It forwards to
 * the profile's own URL once the rollout flag is on, and renders the embedded app in place while
 * it is off.
 */
function JourneysPersonOverviewIndexRoute() {
  const { personId } = Route.useParams();

  return <JourneysPersonOverviewRoute personId={personId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/people/$personId/')({
  component: JourneysPersonOverviewIndexRoute,
});
